import Pusher from 'pusher-js';
import { Observable } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import { PUSHER_CLIENT_KEY, PUSHER_CLUSTER } from 'config/environment';
import { ApiKey } from 'services';
import { authorizer } from './authorizer';

const pusher$ = ApiKey.tokens().pipe(
  switchMap(
    () =>
      new Observable<Pusher>((subscriber) => {
        const pusher = new Pusher(PUSHER_CLIENT_KEY, {
          auth: { headers: ApiKey.header() },
          cluster: PUSHER_CLUSTER,
          authorizer: authorizer(),
        });

        subscriber.next(pusher);

        return () => pusher.disconnect();
      }),
  ),
  shareReplay(1),
);

export const client = (): Observable<Pusher> => pusher$;
